import React from "react";
import { Container } from "react-bootstrap";
import PublicHeader from "../components/Layout/PublicHeader";
import Footer from "../components/Layout/Footer";

const MentionsLegalesPage = () => {
  return (
    <div className="mentions-legales-page">
      <PublicHeader />
      <Container className="py-5">
        <h1 className="mb-4">Mentions Légales</h1>

        <div className="legal-content">
          <p>
            En vertu de l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, il est précisé aux utilisateurs du site marion-livraison.com l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi :
          </p>

          <h2 className="mt-5 mb-3">Propriétaire</h2>
          <p>
            SAS Marion au capital de 30 000 euros - Immatriculée au RCS CANNES sous le numéro Siret 987734472, ayant son siège social au 559 Chemin du Hameau de Plan Sarrain - Domaine du Plan Sarrain - Villa 9 - 06370 MOUANS-SARTOUX.
          </p>

          <h2 className="mt-5 mb-3">Responsable publication</h2>
          <p>
            Sandra RONCE en sa qualité de représentante légale<br />
            Téléphone: 06.61.23.96.33<br />
            Adresse électronique: contact@marion-livraison.com
          </p>

          <h2 className="mt-5 mb-3">Créateur</h2>
          <p>
            LeBackyard au capital de 5 000 euros – Immatriculée au RCS PARIS sous le numéro Siret 819130873 ayant son siège social au 17 Bis Avenue Parmentier - 75011 PARIS
          </p>

          <h2 className="mt-5 mb-3">Hébergeur</h2>
          <p>
            OVH – 2 rue Kellermann – BP 80157 59053 ROUBAIX CEDEX 1
          </p>
        </div>
      </Container>
      <Footer />
    </div>
  );
};

export default MentionsLegalesPage;
